import ExtendedSectionCard from "pages/ManagementPage/questionSection/ExtendedSectionCard/ExtendedSectionCard";

export default ExtendedSectionCard;
